import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noPaymentCardDescription: {
    id: 'paymentCard.noCardDescription',
    defaultMessage:
      'You have no card on file. <addlink>Add it now</addlink>, to be able to start trips.'
  },
  paymentCardUsageDescription: {
    id: 'paymentCard.usageDescription',
    defaultMessage:
      'Your payment card is used to charge for trips and to buy and renew subscriptions.'
  },
  paymentCardExpiredDescription: {
    id: 'paymentCard.paymentCardExpiredDescription',
    defaultMessage: 'A valid card is required to start trips.'
  },
  receiptsLink: {
    id: 'paymentCard.receiptLink',
    defaultMessage:
      'For payment history, see <receiptslink>your receipts</receiptslink>'
  }
});
